class MFRClickToCopy {
  constructor(index, element) {
    this.$index = index;
    this.$element = $(element);

    this.init();
  }

  init() {
    this.$textToCopy = this.$element.attr("data-click-to-copy");

    this.$element.on("click", this.__handleTextClick.bind(this));
  }

  __handleTextClick() {
    navigator.clipboard.writeText(this.$textToCopy);

    if (this.$element.attr("data-toggle")) {
      $(`#${this.$element.attr("data-toggle")}`).text("Copied!");
    }
  }
}